<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(customergroup.id)" v-if="$can('customergroup-delete') && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="customergroup.name"
                  v-model="customergroup.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('customergroups.name')"
                  :error-messages="errors.collect('customergroup.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="customergroup.status"
                  v-model="customergroup.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_customer_group_status()"
                  :label="$t('customergroups.status')"
                  :error-messages="errors.collect('customergroup.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CustomerGroupForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      customergroup: {
        has_locale: false
      },
      dictionary: {
        attributes: {
          "customergroup.name": this.$t("customergroups.name"),
          "customergroup.status": this.$t("customergroups.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.customergroup, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.customergroup = {
        has_locale: false,
        status: this.$getDefaultDropdown(this.$dd_customer_group_status())
      }

      // JSON stringify and parse to remove variable reactiveness
      this.customergroup = JSON.parse(JSON.stringify(this.customergroup))

      this.setPageTitle()
    } else {
      this.title = this.$t("customergroups.update_title")

      axios
        .get(this.API_URL + "customergroup/" + this.id)
        .then((res) => {
          this.customergroup = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.customergroup = JSON.parse(JSON.stringify(this.customergroup))

          this.setPageTitle()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setPageTitle() {
      if (_.has(this.customergroup, "id")) {
        this.page_title = this.$t("customergroups.edit_customergroup", {
          name: this.customergroup.name
        })
      } else {
        this.page_title = this.$t("customergroups.new_customergroup")
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.customergroup.id) {
              // Create
              axios
                .post(this.API_URL + "customergroup", {
                  name: this.customergroup.name,
                  status: this.customergroup.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "customergroup",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.customergroup = res.data.data
                        vm.predata = JSON.parse(JSON.stringify(vm.customergroup))

                        vm.setPageTitle()
                        vm.$router.replace(this.BACKEND_URL + `/customergroups/edit/${vm.customergroup.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "customergroup", {
                  id: this.customergroup.id,
                  name: this.customergroup.name,
                  status: this.customergroup.status
                })
                .then((res) => {
                  vm.customergroup = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.customergroup))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "customergroup",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "customergroup/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/customergroups")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
